import { Carousel as JLDSCarousel } from "@JohnLewisPartnership/jl-design-system/dist/components/carousel/Carousel";
import { ProductCard } from "../ProductCard";
import { ProductListLayout } from "@~/types/types.ts";
import { getProductKey } from "../utils/getProductKey";

function validateHeadingSize(s: unknown): "small" | "large" | undefined {
  switch (s) {
    case "small":
      return "small";
    case "large":
      return "large";
    default:
      return undefined;
  }
}

export const Carousel: ProductListLayout = ({ config, products, heading }) => {
  const headingSize = validateHeadingSize(
    config["product-list-layout"]?.props?.headingSize,
  );

  return (
    <JLDSCarousel
      id="carousel"
      ariaLabel="carousel"
      heading={heading?.main}
      subheading={heading?.subHeading ?? undefined}
      headingSize={headingSize}
    >
      {products.map((product, ind) => (
        <ProductCard
          key={getProductKey(product)}
          product={product}
          config={config}
          index={ind}
        />
      ))}
    </JLDSCarousel>
  );
};
